import React, { useState, useEffect } from "react";
import axios from "axios";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const SettingLayer = () => {
  const [settings, setSettings] = useState([]);
  const [allsettings, setAllSettings] = useState([]);
  const [statuschanged, setStatuschanged] = useState(false);
  const [addedNewRow, setAddedNewRow] = useState(true);
  const [NewRow, setNewRow] = useState(<></>);

  const [keyError, setKeyError] = useState(false);
  const [valError, setValError] = useState(false);
 
  useEffect(() => {
    // Fetch data
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "setting-list")
      .then((response) => {
        let allsettinginfo=[];
        let settingrows = response.data.data;
        console.log("settingrows", settingrows);
   
        settingrows.map((post, i) => {
          console.log("post", post, post.setting_key);
   
          allsettinginfo[post.id]= {setting_key: post.setting_key,setting_value: post.setting_value,comments: post.comments};
        });
console.log("allsettinginfo", allsettinginfo);
        setAllSettings(allsettinginfo);
        setSettings(response.data.data);
      
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    


  }, [statuschanged]);
 
  const saveSettings = async (id ="new") => {
 
    let settingkey = "";
    let settingvalue = "";
    let comments = "";
    
    if(id === "new") {
        settingkey = document.getElementById("settingkey")?.value;
        settingvalue = document.getElementById("settingval")?.value;
        comments = document.getElementById("comments")?.value;
        var formData = {
            setting_key: settingkey,
            setting_value: settingvalue,
            comments: comments
          };
          console.log(formData);
         
        if(settingkey && settingvalue && settingkey !== "" && settingvalue !== ""){
            setKeyError(false);
            setValError(false);
             
          axios
            .post(
              process.env.REACT_APP_API_BASE_URL+"setting-add",
              { ...formData },
            )
            .then((res) => {
              console.log(res.data);
              if (res.data.status === true) {
                toast.success("New Setting created sucessfully!!");
                setNewRow("");
                setStatuschanged(!statuschanged);
              } else {
                toast.error("something went wrong...");
              }
            })
            .catch((err) => {
              console.error(err);
              toast.error(err);
            });
        } else{
             if(!settingkey){
                setKeyError(true);
            }
            if(!settingvalue){
                setValError(true);
            }           
        }
    } else {
        settingkey = document.getElementById("settingkey_"+id)?.value;
        settingvalue = document.getElementById("settingval_"+id)?.value;
        comments = document.getElementById("comments_"+id)?.value;
       if(settingkey !=="" && settingvalue!==""){
            var updformData = {
            setting_key: settingkey,
            setting_value: settingvalue,
            comments: comments
          };
          console.log(updformData);
        axios
        .post(
          process.env.REACT_APP_API_BASE_URL+"setting-update/" + id,
          { ...updformData }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.status === true) {
            toast.success("Setting updated sucessfully!!");
            setStatuschanged(!statuschanged);
           
          } else {
            toast.error("something went wrong...");
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(err);
        });
    }
    }
}


  const getRow = () => {
    let tbody =document.getElementById("settingbody");
   let count = tbody!=null && tbody.rows ?tbody.rows.length:0;

    return (
      <tr>
       
        <td>
          <div className="form-check style-check d-flex align-items-center">
            <label className="form-check-label">
            {count+1}
            </label>
          </div>
        </td>
        <td>
          <input
            type="text"
            id="settingkey"
            name="settingkey"
            className={keyError ? "border-red form-control" : "form-control" }
           />  
          {keyError && <p className="text-red">Setting Key is mandatory</p>}
        </td>
        <td>
          <input
            type="text"
            id="settingval"
            name="settingval"

            className={valError ? "border-red form-control" : "form-control" }
          />
            {valError && <p className="text-red">Setting Value is mandatory</p>}
      
        </td>
        <td>
          <input
            type="text"
            id="comments"
            name="comments"
            className="form-control"
          /> 
        </td>
        <td>
        <Link
                                                onClick={() => saveSettings('new')}
                                                className="btn btn-sm btn-xs btn-primary  justify-content-center"
                                            >
                                                Save  
                                            </Link> 
        </td>
      </tr>
    );
  };
  const addSettingRow = () => {
    let newRow = getRow();
    setNewRow(newRow);
    setAddedNewRow(false);

  }

  const handleChange = (postid,fieldkey, newValue) => {

    const newData = allsettings.map((row, i) =>{
      if(i === postid){
        row[fieldkey]= newValue;
        return row;
      }else{
return row;
      }
    } 
    );
     setAllSettings(newData);
 
  };

  console.log('addedNewRow:', addedNewRow);
  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0"></h5>
      </div>
      <ToastContainer></ToastContainer>
      <div className="card-body">
        <table
          className="table bordered-table mb-0"
          id="dataTable"
          data-page-length={10}
        >
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check style-check d-flex align-items-center">
                  <label className="form-check-label">S.L</label>
                </div>
              </th>
              <th scope="col">Setting Key</th>
              <th scope="col">Setting Value</th>
              <th scope="col">Comments </th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody id="settingbody">
          <tr><th scope="col" colSpan={5}> Loyalty Program</th> </tr>
        
            {settings.map((post, i) => (
              <tr>
                <td>
                  <div className="form-check style-check d-flex align-items-center">
                    <label className="form-check-label">{i + 1}</label>
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    readOnly
                    id={"settingkey_" + post.id}
                    name={"settingkey[" + post.id + "]"}
                    class="form-control"
                    value={allsettings[post.id]['setting_key']}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    id={"settingval_" + post.id}
                    name={"settingval[" + post.id + "]"}
                    class="form-control"
                    value={allsettings[post.id]['setting_value']}
                    onChange={(e) => handleChange(post.id,"setting_value", e.target.value)}
        
                   
                  />
                </td>
                <td>
                  <input
                    type="text"
                    id={"comments_" + post.id}
                    name={"comments[" + post.id + "]"}
                    class="form-control"
                    value={allsettings[post.id]['comments']}
                    onChange={(e) => handleChange(post.id,"comments", e.target.value)}
        
                  />
                </td>
                <td>
                <Link
                                                onClick={() => saveSettings(post.id)}
                                                className="btn btn-sm btn-xs btn-primary  justify-content-center"
                                            >
                                                Save 
                                            </Link>  
                  
                </td>
              </tr>
            ))}
           
           {NewRow}
          </tbody>
          
        </table>
        {addedNewRow &&   <div  style={{ textAlign: "right",width:"100%" }}>
              <Link
                                                onClick={() => addSettingRow()}
                                                className="btn btn-sm btn-xs btn-secondary  justify-content-center"
                                            >
                                                  Add new Setting 
                                            </Link> 
                  
              </div>}
            
      </div>
    </div>
  );
};

export default SettingLayer;
